const translations = {
  name: 'Name',
  namePlural: 'Plural name',
  icon: 'Icon',
  title: 'Place types',
  titleEdit: 'Edit place types',
  insertedAt: 'Created at: ',
  updatedAt: 'Updated at: ',
  'edit.title': 'Editing',
  'create.title': 'Creating',
  placeType: 'place type',
  requiredField: 'Required field',
  successSave: 'Place type saved successfully!',
  errorSave: 'An error occurred while saving!'
}

export default translations
